import classNames from "classnames";

import styles from "./gift-card-checkout-notification.module.scss";

type GiftCardCheckoutNotificationProps = {
    email?: string;
    headerText: string;
    icon?: React.ReactNode;
    isError?: boolean;
    messageText: string;
};

export const GiftCardCheckoutNotification: React.FC<GiftCardCheckoutNotificationProps> = ({
    email,
    headerText,
    icon,
    isError = false,
    messageText,
}) => (
    <div className={classNames(styles.container, { [styles.errorState]: isError })}>
        {icon && <div className={styles.iconWrapper}>{icon}</div>}
        <h2 className={styles.header}>{headerText}</h2>
        <div className={styles.messageContainer}>
            <p>{messageText}</p>
            {email && <span className={styles.email}>{email}</span>}
        </div>
    </div>
);
